import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import Column from "apps/website/components/layout/Column/Column";
import Container from "apps/website/components/layout/Container/Container";
import Grid from "apps/website/components/layout/Grid/Grid";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import Image from "apps/website/components/base/Image/Image";
import ImageTextList from "apps/website/components/feature/ImageTextList/ImageTextList";
import Button from "apps/website/components/base/Button/Button";

import { data } from "./data";

export default function SectionIncredibleHealthBenefitsVariant() {
  return (
    <div>
      <div className="bg-light-grey">

        <Container>
          <Grid gap="lg">
            <Column spans={ { xl: 12 }} justify="center" align="center" className="py-8 lg:pt-12 lg:pb-16 flex flex-col gap-y-8 lg:gap-y-10">
              <TextTitle tag="h2" align="center" whitespace="balance" data-testid="SectionIncredibleHealthBenefitsVariant-title">
                { data.title }
              </TextTitle>
              <TextSubtitle align="center" whitespace="balance" size={1} data-testid="SectionIncredibleHealthBenefitsVariant-subtitle">
                { data.subtitle }
              </TextSubtitle>

              <div>
                <ImageTextList items={ data.imageTextListItems } columns="[2,4]" flow="row" itemTitleTag="h3" />
              </div>
            </Column>
            <Column justify="center" align="center">
              <div className="p-4 pb-12">
                <Button to="/forms/fresh-new-user" data-testid="SectionIncredibleHealthBenefitsVariant-cta">Transform their health today</Button>
              </div>
            </Column>
          </Grid>
        </Container>
      </div>
      <div className="relative w-full h-[280px] lg:h-[500px]">
        <Image
          image={ {
            src: data.image.src,
            width: data.image.width,
            height: data.image.height,
          } }
          alt={ data.image.alt }
          cover
          data-testid="SectionIncredibleHealthBenefitsVariant-image"
        />
      </div>
    </div>
  );
}
